import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';

const AuthLayout = () => import('@/layouts/AuthLayout');
const DashboardLayout = () => import('@/layouts/DashboardLayout');

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');

const Workouts = () => import('@/views/Workouts');
const ContentSettings = () => import('@/views/ContentSettings');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: { name: 'Login' },
  },
  {
    path: '/',
    component: AuthLayout,
    name: 'AuthLayout',
    children: [
      {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { onlyNotAuthorized: true },
      },
    ],
  },
  {
    path: '/',
    name: 'DashboardLayout',
    component: DashboardLayout,
    children: [
      {
        path: '/workouts',
        name: 'Workouts',
        component: Workouts,
      },
      {
        path: '/content-settings',
        name: 'ContentSettings',
        component: ContentSettings,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = store.getters['auth/token'];
  // let user = store.getters['auth/user'];

  // if (!user && token) {
  //   try {
  //     await store.dispatch('auth/loadMe');
  //     user = store.getters['auth/user'];
  //   } catch (e) {
  //     if (to.meta.allowed) return next({ name: 'login' });
  //   } finally {
  //     store.commit('auth/setInitialized');
  //   }
  // }
  //
  // if (user) {
  //   if (to.meta?.onlyNotAuthorized) {
  //     return next({ name: 'Orders' });
  //   }
  //   return next();
  // }

  if (token) {
    if (to.meta?.onlyNotAuthorized) {
      return next({ name: 'Workouts' });
    }
    return next();
  }
  if (!to.meta?.onlyNotAuthorized) return next({ name: 'Login' });

  next();
});

export default router;
